export const GET_PAYMENTS_REQUEST = 'GET_PAYMENTS_REQUEST';
export const GET_PAYMENTS_SUCCESS = 'GET_PAYMENTS_SUCCESS';
export const GET_PAYMENTS_FAILURE = 'GET_PAYMENTS_FAILURE';

export const GET_BALANCES_REQUEST = 'GET_BALANCES_REQUEST';
export const GET_BALANCES_SUCCESS = 'GET_BALANCES_SUCCESS';
export const GET_BALANCES_FAILURE = 'GET_BALANCES_FAILURE';

export const SET_DEFAULTS = 'SET_DEFAULTS';
